<template>
  <div :class="[this.currentLanguage == 'AR' ? 'rtlText': '']">
    <div class="page-content">
      <section class="section--products section--categories">
        <div class="section__inner" style="padding-right: 20px">
          <div class="section__box section__box--nobg">
            <h2 class="box-title box-title--category"><span :class="[this.currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("search.titleText") }}</span> "{{ word }}"</h2>
            <div class="category-products" v-if="this.searchResults.length > 0">
              <div
                :class="isBookType ? 'card--v4 card--ebook' : 'card--v4'"
                v-for="item in searchResults"
                :key="item.product_id"
              >
                <router-link
                  :event="isLoggedIn ? 'click' : ''"
                  :to="{
                    name: 'ProductDetails',
                    params: {
                      type: helpers.portal_name,
                      productId: item.product_id,
                    },
                  }"
                  @click.native="
                    checkIsLogged({
                      name: 'ProductDetails',
                      params: {
                        type: helpers.portal_name,
                        productId: item.product_id,
                      },
                    })
                  "
                >
                  <div class="item-img">
                    <img :src="item.icon_small" :alt="title" />
                  </div>
                  <div class="item-data">
                    <div class="data-value">
                      <h3 class="data-title">{{ item.title }}</h3>
                      <div class="data-category">
                        {{ item.short_description }}
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <div v-else>
              <p>No search result.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import EventBus from "../helper/event_bus";
import { helpers } from "../helper/portal_config";

export default {
  name: "SearchResult",
  title: helpers.portal_name,
  data() {
    return {
      products: [],
      helpers: "",
      title: "",
    };
  },
  methods: {
    checkIsLogged(link) {
      // if you are not login than showed modal
      if (!this.isLoggedIn) {
        EventBus.$emit("SHOW_SIGNIN_MODAL", link);
      }
    },
  },
  computed: {
    ...mapGetters({
      accessCode: "globals/accessCode",
      isLoggedIn: "globals/isLoggedIn",
      searchResults: 'globals/searchResults',
      word: 'globals/query',
    }),
    isBookType() {
      return this.helpers.portal_name == "Carefizz"; // change ebook portal name
    },
  },
  created() {
    this.helpers = helpers;
    //this.word = this.$route.query.q;
  },
};
</script>

<style scoped>
.card--v4.card--ebook .item-img img {
  object-fit: contain;
  object-position: top;
}

.card--v4.card--ebook .item-img {
  width: 50px;
  height: 90px;
}

@media (min-width: 1200px) {
  .card--v4.card--ebook .item-img {
    width: 90px;
    height: 120px;
  }
}

@media (min-width: 1600px) {
  .card--v4.card--ebook .item-img {
    width: 80px;
    height: 135px;
  }
}
</style>
